function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T, useTranslate } from 'shared/helper/translate';
import { updateCardlessTrialPlanItems, activateCardlessTrialUpgrade, fetchCardlessPaymentMethodTransaction } from 'rubriq/actions';
import { getCardlessUpgradePlanOptions } from 'rubriq/reducer';
import usePaddleCheckout from 'rubriq/hooks/usePaddleCheckout';
import { PADDLE_PLAN_TYPES } from '../constants';
import { PAGE_TERMS, PLAN_TERMS } from './pricing/pricingContent';
import useRowPlanPricing from './pricing/row/useRowPlanPricing';

/** The two paid cards, in the order the pricing page lists them. */
var UPGRADE_PLAN_GROUPS = [{
  key: 'editing',
  titleTerm: PLAN_TERMS.premium.title,
  productName: 'Rubriq Premium'
}, {
  key: 'translation',
  titleTerm: PLAN_TERMS.translation.title,
  productName: 'Rubriq Premium with Translation'
}];
var BILLING_INTERVAL_TERMS = _defineProperty(_defineProperty({}, PADDLE_PLAN_TYPES.MONTHLY, PAGE_TERMS.monthly), PADDLE_PLAN_TYPES.YEARLY, PAGE_TERMS.annual);

/**
 * 4-step Paddle upgrade modal for cardless-trial users.
 *
 * Correct order per Paddle docs / error "subscription_price_requires_payment_method_on_cardless_trial":
 *   Step 1 – User picks a paid plan (Editing Only or with Translation) + billing cycle
 *   Step 2 – Collect payment method via update-payment-method-transaction + one-page checkout
 *             ↑ Must happen BEFORE updating subscription items on a cardless subscription
 *   Step 3 – PATCH /subscriptions/{id} (update items to chosen plan, do_not_bill)
 *   Step 4 – POST /subscriptions/{id}/activate (charges + activates immediately)
 */
var CardlessTrialUpgradeModal = function CardlessTrialUpgradeModal(_ref) {
  var _stepIndex$step;
  var open = _ref.open,
    onClose = _ref.onClose,
    _ref$onSuccess = _ref.onSuccess,
    onSuccess = _ref$onSuccess === void 0 ? function () {} : _ref$onSuccess,
    _ref$initialPriceId = _ref.initialPriceId,
    initialPriceId = _ref$initialPriceId === void 0 ? null : _ref$initialPriceId;
  var dispatch = useDispatch();
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var openCheckout = usePaddleCheckout();
  var _useRowPlanPricing = useRowPlanPricing(),
    getPlanAmount = _useRowPlanPricing.getPlanAmount,
    getPlanPrice = _useRowPlanPricing.getPlanPrice;

  // step: 'select' | 'payment' | 'items' | 'activate' | 'done'
  var _useState = useState('select'),
    _useState2 = _slicedToArray(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedPlan = _useState4[0],
    setSelectedPlan = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMsg = _useState6[0],
    setErrorMsg = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isProcessing = _useState8[0],
    setIsProcessing = _useState8[1];
  var planOptions = useSelector(getCardlessUpgradePlanOptions);

  // -----------------------------------------------------------------------
  // Plan options the user can upgrade to, in the order the pricing page lists them
  // -----------------------------------------------------------------------
  var buildPlanRows = function buildPlanRows() {
    if (!planOptions) return [];
    return UPGRADE_PLAN_GROUPS.flatMap(function (_ref2) {
      var key = _ref2.key,
        titleTerm = _ref2.titleTerm,
        productName = _ref2.productName;
      return [PADDLE_PLAN_TYPES.MONTHLY, PADDLE_PLAN_TYPES.YEARLY].filter(function (billingInterval) {
        return planOptions[key][billingInterval];
      }).map(function (billingInterval) {
        return {
          plan: planOptions[key][billingInterval],
          title: t(titleTerm),
          productName: productName,
          billingLabel: t(BILLING_INTERVAL_TERMS[billingInterval]),
          price: getPlanPrice(planOptions[key][billingInterval])
        };
      });
    });
  };
  var planRows = buildPlanRows();
  var selectedRow = planRows.find(function (row) {
    return row.plan.paddlePlanId === (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.paddlePlanId);
  });
  var selectedPlanLabel = selectedRow ? "".concat(selectedRow.title, " (").concat(selectedRow.billingLabel, ")") : '';

  // A plan card's own CTA opens this modal for that specific plan — preselect it so the
  // user only has to confirm. The header UPGRADE button passes no initialPriceId and the
  // user picks from the list instead.
  useEffect(function () {
    if (!open || !initialPriceId) return;
    var row = planRows.find(function (r) {
      return r.plan.paddlePlanId === initialPriceId;
    });
    if (row) {
      setSelectedPlan(row.plan);
    }
  }, [open, initialPriceId]);

  // -----------------------------------------------------------------------
  // Step 1 – User confirms plan selection
  // -----------------------------------------------------------------------
  var handleSelectPlan = function handleSelectPlan() {
    if (!selectedPlan) return;
    setErrorMsg(null);
    setStep('payment');
  };

  // -----------------------------------------------------------------------
  // Step 2 – Collect payment method (MUST be before updating items)
  // -----------------------------------------------------------------------
  var handleCollectPayment = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var transactionId;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsProcessing(true);
            setErrorMsg(null);
            _context.prev = 2;
            _context.next = 5;
            return dispatch(fetchCardlessPaymentMethodTransaction());
          case 5:
            transactionId = _context.sent;
            _context.next = 8;
            return openCheckout(transactionId);
          case 8:
            if (!_context.sent) {
              _context.next = 10;
              break;
            }
            setStep('items');
          case 10:
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);
            setErrorMsg(_context.t0.message || 'Failed to open payment form. Please try again.');
          case 15:
            _context.prev = 15;
            setIsProcessing(false);
            return _context.finish(15);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 12, 15, 18]]);
    }));
    return function handleCollectPayment() {
      return _ref3.apply(this, arguments);
    };
  }();

  // -----------------------------------------------------------------------
  // Step 3 – Update subscription items to the chosen plan (do_not_bill)
  // -----------------------------------------------------------------------
  var handleUpdateItems = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setIsProcessing(true);
            setErrorMsg(null);
            _context2.prev = 2;
            _context2.next = 5;
            return dispatch(updateCardlessTrialPlanItems({
              priceId: selectedPlan.paddlePlanId
            }));
          case 5:
            setStep('activate');
            _context2.next = 11;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](2);
            setErrorMsg(_context2.t0.message || 'Failed to update plan. Please try again.');
          case 11:
            _context2.prev = 11;
            setIsProcessing(false);
            return _context2.finish(11);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 8, 11, 14]]);
    }));
    return function handleUpdateItems() {
      return _ref4.apply(this, arguments);
    };
  }();

  // -----------------------------------------------------------------------
  // Step 4 – Activate immediately (charges the card)
  // -----------------------------------------------------------------------
  var handleActivate = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setIsProcessing(true);
            setErrorMsg(null);
            _context3.prev = 2;
            _context3.next = 5;
            return dispatch(activateCardlessTrialUpgrade({
              plan: selectedPlan,
              amount: getPlanAmount(selectedPlan),
              productName: selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.productName
            }));
          case 5:
            setStep('done');
            onSuccess();
            _context3.next = 12;
            break;
          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](2);
            if (_context3.t0.message === 'missing-payment-method') {
              setErrorMsg('Payment method not yet recorded. Please add your card again.');
              setStep('payment');
            } else {
              setErrorMsg(_context3.t0.message || 'Activation failed. Please try again.');
            }
          case 12:
            _context3.prev = 12;
            setIsProcessing(false);
            return _context3.finish(12);
          case 15:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 9, 12, 15]]);
    }));
    return function handleActivate() {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleClose = function handleClose() {
    if (isProcessing) return;
    setStep('select');
    setSelectedPlan(null);
    setErrorMsg(null);
    onClose();
  };

  // Step progress indicator
  var stepLabels = ['Choose plan', 'Add payment', 'Update plan', 'Activate'];
  var stepIndex = {
    select: 0,
    payment: 1,
    items: 2,
    activate: 3,
    done: 3
  };
  var currentIdx = (_stepIndex$step = stepIndex[step]) !== null && _stepIndex$step !== void 0 ? _stepIndex$step : 0;
  return /*#__PURE__*/React.createElement(Modal, {
    appElement: window.document.querySelector('#researcher-app') || document.body,
    className: "react-modal",
    isOpen: open,
    overlayClassName: "react-modal-overlay",
    onRequestClose: handleClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-header"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    onClick: handleClose,
    "aria-label": t('close'),
    disabled: isProcessing
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/React.createElement("h1", {
    className: "react-modal-title modal-start-heading"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Upgrade to Paid Plan"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-content pb-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center gap-3 mb-4"
  }, stepLabels.map(function (label, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: label,
      className: "d-flex flex-column align-items-center"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: '2rem',
        height: '2rem',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '0.25rem',
        backgroundColor: i <= currentIdx ? '#198754' : '#dee2e6',
        color: i <= currentIdx ? '#fff' : '#6c757d',
        fontSize: '0.85rem',
        fontWeight: 'bold'
      }
    }, i < currentIdx || step === 'done' ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-check"
    }) : i + 1), /*#__PURE__*/React.createElement("small", {
      style: {
        color: i <= currentIdx ? '#198754' : '#6c757d',
        fontSize: '0.7rem'
      }
    }, label));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-content"
  }, step === 'select' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Choose the plan you want to upgrade to:"
  })), planRows.length === 0 && /*#__PURE__*/React.createElement("p", {
    className: "text-muted small"
  }, /*#__PURE__*/React.createElement(T, {
    source: "No plans available. Please refresh and try again."
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-2"
  }, planRows.map(function (row) {
    return /*#__PURE__*/React.createElement("label", {
      key: row.plan.paddlePlanId,
      className: "d-flex align-items-center gap-3 p-3 border rounded cursor-pointer ".concat((selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.paddlePlanId) === row.plan.paddlePlanId ? 'border-primary bg-light' : ''),
      style: {
        cursor: 'pointer'
      }
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      name: "upgrade-plan",
      value: row.plan.paddlePlanId,
      checked: (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.paddlePlanId) === row.plan.paddlePlanId,
      onChange: function onChange() {
        return setSelectedPlan(row.plan);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex-grow-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fw-semibold"
    }, row.title), /*#__PURE__*/React.createElement("div", {
      className: "text-muted small"
    }, row.billingLabel)), /*#__PURE__*/React.createElement("div", {
      className: "fw-bold"
    }, row.price));
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-muted small mt-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "No charge happens at this step."
  }))), step === 'payment' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
    source: "You selected %(plan)s. Add a payment method to continue \u2014 no charge yet.",
    params: {
      plan: selectedPlanLabel
    }
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-muted small"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Your card details are securely handled by Paddle."
  }))), step === 'items' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
    source: "Payment method saved. Click Continue to switch your subscription to %(plan)s.",
    params: {
      plan: selectedPlanLabel
    }
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-muted small"
  }, /*#__PURE__*/React.createElement(T, {
    source: "No charge yet \u2014 you will be charged in the next step."
  }))), step === 'activate' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
    source: "Everything is ready. Click Confirm to activate %(plan)s now. You will be charged immediately.",
    params: {
      plan: selectedPlanLabel
    }
  }))), step === 'done' && /*#__PURE__*/React.createElement("div", {
    className: "text-center py-3"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-circle-check",
    className: "text-success mb-2",
    style: {
      fontSize: '2.5rem'
    }
  }), /*#__PURE__*/React.createElement("p", {
    className: "fw-bold mt-2"
  }, /*#__PURE__*/React.createElement(T, {
    source: "You are now subscribed to %(plan)s!",
    params: {
      plan: selectedPlanLabel
    }
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-muted small"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Your account has been upgraded."
  }))), errorMsg && /*#__PURE__*/React.createElement("div", {
    className: "alert alert-danger mt-3 mb-0 small",
    role: "alert"
  }, errorMsg)), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-footer"
  }, step === 'select' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary btn-squared me-3",
    onClick: handleSelectPlan,
    disabled: !selectedPlan
  }, /*#__PURE__*/React.createElement(T, {
    source: "Continue"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-secondary btn-squared",
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(T, {
    source: "cancel"
  }))), step === 'payment' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary btn-squared me-3",
    onClick: handleCollectPayment,
    disabled: isProcessing
  }, isProcessing && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true,
    className: "me-1"
  }), /*#__PURE__*/React.createElement(T, {
    source: "Add payment method"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-secondary btn-squared",
    onClick: handleClose,
    disabled: isProcessing
  }, /*#__PURE__*/React.createElement(T, {
    source: "cancel"
  }))), step === 'items' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary btn-squared me-3",
    onClick: handleUpdateItems,
    disabled: isProcessing
  }, isProcessing && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true,
    className: "me-1"
  }), /*#__PURE__*/React.createElement(T, {
    source: "Continue"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-secondary btn-squared",
    onClick: handleClose,
    disabled: isProcessing
  }, /*#__PURE__*/React.createElement(T, {
    source: "cancel"
  }))), step === 'activate' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary btn-squared me-3",
    onClick: handleActivate,
    disabled: isProcessing
  }, isProcessing && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true,
    className: "me-1"
  }), /*#__PURE__*/React.createElement(T, {
    source: "Confirm & Pay Now"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-secondary btn-squared",
    onClick: handleClose,
    disabled: isProcessing
  }, /*#__PURE__*/React.createElement(T, {
    source: "cancel"
  }))), step === 'done' && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary btn-squared",
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(T, {
    source: "Close"
  }))));
};
export default CardlessTrialUpgradeModal;